import { attribute, autoGeneratedHashKey } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { dynamicTableName } from '@pristine-ts/aws';
import { CalculationKeynameEnum } from '../enums/calculations/calculation-keyname.enum';
import { CalculationError } from '../errors/calculations/calculation.error';
import { property } from '@pristine-ts/metadata';
import { array } from '@pristine-ts/data-mapping-common';
import { CalculationWarning } from '../warnings/calculation.warning';

@dynamicTableName('CALCULATION_RESULT_TABLE_NAME')
export class CalculationResultModel {
  @autoGeneratedHashKey()
  @property()
  id: string;
  @attribute()
  @property()
  calculationId: string;
  @attribute()
  @property()
  calculationKeyname: CalculationKeynameEnum;
  @array(CalculationError)
  @attribute()
  errors: CalculationError[] = [];
  @attribute({ unwrapNumbers: true })
  @property()
  results: any;
  @attribute()
  @property()
  warnings: CalculationWarning[] = [];
  @attribute()
  @property()
  createdAt: Date;
  @attribute()
  @property()
  updatedAt: Date;
}
